import type { ReactNode } from 'react'

import { ClassReachProvider } from './ClassReachProvider'
import { ClassBrowserMenuProvider } from './learner/ClassBrowserMenuProvider'

/** Classes' app-wide provider: the Browse Classes nav switch, and which classes the caller may open. */
export function ClassesProvider(props: { readonly children: ReactNode }) {
  return (
    <ClassBrowserMenuProvider>
      <ClassReachProvider>{props.children}</ClassReachProvider>
    </ClassBrowserMenuProvider>
  )
}
